import React, { useEffect } from 'react';
import moment from 'moment'
import 'react-table-6/react-table.css'
import { useSelector, useDispatch }from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import { Utils, Filters } from '../../../services';
import PageTitle from '../../../components/PageTitle/PageTitle';
import Table from '../../../components/Table';
import TableButtons from '../../../components/TableButtons';
import CreateButton from '../../../components/CreateButton';

import { loadPeriods } from '../../../redux/modules/periods';

import './PeriodsList.css';

const PeriodsList = () => {
    const { t }        = useTranslation();
    const { periods }   = useSelector(state => state.periods);
    const dispatch     = useDispatch();
    const default_lang = Utils.default_lang();

    useEffect(() => {
        dispatch(loadPeriods());
    }, [dispatch]);

    const title = <span>{t("periods.period", {count: 42})}</span>;

    const actions = <CreateButton module={`periods`} text="periods.add" />;

    const columns = [{
        Header: t('periods.name'),
        accessor: "name",
        filterMethod: Filters.textFilterMethod("name." + default_lang),
        Filter: Filters.textFilter,
        filterAll: true,
        Cell: row => row.value && (
            <div className="name_cell">
                <Link to={`/periods/edit/${row.original.id}`}>
                    {row.original.name[default_lang]}
                </Link>
            </div>
        )
    }, {
        Header: t("periods.active_from") + ' / ' + t("periods.active_until"),
        Filter: Filters.textFilter(false),
        filterMethod: Filters.textFilterMethod('start_at'),
        filterAll: true,
        accessor: 'start_at',
        Cell: row => {
            const start_at = row.value;
            const stop_at  = row.original.stop_at;
            return (
                <>
                    <i className="fa fa-clock-o"></i>&nbsp;{start_at}<br />
                    <i className="fa fa-clock-o"></i>&nbsp;{stop_at}<br />
                </>
            )
        }
    }, {
        Header: t('common.actions'),
        accessor: "id",
        maxWidth: 110,
        filterable: false,
        Cell: row => (
            <TableButtons
                id={row.value}
                actions={["edit", "delete"]}
                module="periods"
            />
        )
    }];

    return (
        <div className="PeriodsList">
            <PageTitle icon="sun-o" title={ title } actions={ actions } />
            <Table id="periodsTable" data={ periods } columns={ columns } />
        </div>
    );
}

export default PeriodsList;
